import React, { useState } from "react";
import "./AddPackage.css";

// components imports
import Loader from "../../../../../../../Components/CircularLoader/CircularLoader";
// apis imports
import { addNewPackage } from "../../../../../../../services/ShipperServices/Packages/packages.services";

// library imports
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import { useSelector } from "react-redux";
import Upload from "@mui/icons-material/CloudUpload";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { useTranslation } from "react-i18next";

const initialData = {
  name: "",
  description: "",
  length: "",
  width: "",
  height: "",
  weight: "",
  unit: "Imperial",
  picture: null,
};

// What to tell the user about a field left empty.
const REQUIRED_MESSAGES = {
  name: "packages.form.required.name",
  description: "packages.form.required.description",
  length: "packages.form.required.length",
  width: "packages.form.required.width",
  height: "packages.form.required.height",
  weight: "packages.form.required.weight",
  unit: "packages.form.required.unit",
};

export default function AddPackage({ open, setOpen, setSnack, setRefresh }) {
  const { t } = useTranslation("products");
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setData(initialData);
    setOpen(false);
  };
  const user = useSelector((state) => state.user);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };
  const handleUnitChange = (e) => {
    setData({ ...data, unit: e.target.value });
  };
  const handleFileChange = (e) => {
    setData({ ...data, picture: e.target.files[0] });
  };

  const handleSave = async () => {
    setLoading(true);
    for (const key in data) {
      if (data[key] === "") {
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: t(REQUIRED_MESSAGES[key] ?? "packages.form.fillEvery"),
            severity: "error",
          };
        });
        setLoading(false);
        return;
      }
    }

    const payload = {
      length: data.length,
      name: data.name,
      save_name:
        data.name +
        "    " +
        "   " +
        data.length +
        "*" +
        data.width +
        "*" +
        data.height +
        "    " +
        data.weight +
        (data.unit === "Imperial" ? " lbs" : " kg"),
      weight: data.weight,
      width: data.width,
      height: data.height,
      unit: data.unit,
      description: data.description,
      file: data.picture,
    };
    const formData = new FormData();
    formData.append("name", payload.name);
    formData.append("save_name", payload.save_name);
    formData.append("description", payload.description);
    formData.append("length", payload.length);
    formData.append("width", payload.width);
    formData.append("height", payload.height);
    formData.append("weight", payload.weight);
    formData.append("unit", payload.unit);
    payload.file && formData.append("file", payload.file);
    const saved = await addNewPackage(formData);
    setLoading(false);
    if (!saved.error) {
      setRefresh(Math.floor(Math.random() * 100) + 1);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("packages.form.added"),
          severity: "success",
        };
      });
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }

    handleClose();
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="add__package_modal">
          <div className="add__package_modalheading">{t("packages.add")}</div>
          <div className="add__package_modalcontent">
            <div className="add__package_modalrow">
              <div
                className="add__package_modalinputwrap"
                style={{ minWidth: "65%" }}
              >
                <input
                  className="add__package_modalinput"
                  placeholder={t("packages.form.name")}
                  name="name"
                  value={data.name}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="add__package_modalrow">
              <div
                className="add__package_modalinputwrap"
                style={{ minWidth: "65%" }}
              >
                <input
                  className="add__package_modalinput"
                  placeholder={t("packages.form.description")}
                  name="description"
                  value={data.description}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="add__package_modalrow">
              <div className="add__package_modalinputwrap">
                <input
                  className="add__package_modalinput"
                  placeholder={t("packages.form.length")}
                  name="length"
                  value={data.length}
                  onChange={handleChange}
                  type="number"
                />
              </div>
              <div className="add__package_modalinputwrap">
                <input
                  className="add__package_modalinput"
                  placeholder={t("packages.form.width")}
                  name="width"
                  value={data.width}
                  onChange={handleChange}
                  type="number"
                />
              </div>
              <div className="add__package_modalinputwrap">
                <input
                  className="add__package_modalinput"
                  placeholder={t("packages.form.height")}
                  name="height"
                  value={data.height}
                  onChange={handleChange}
                  type="number"
                />
              </div>
              <div className="add__package_modalinputwrap">
                <input
                  className="add__package_modalinput"
                  type="number"
                  value={data.weight}
                  name="weight"
                  placeholder={t("packages.form.weight")}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="add__package_modalrow">
              <div className="add__package_modalinputwrap">
                <FormControl
                  sx={{
                    flexDirection: "row",
                    alignItems: "center",
                    paddingLeft: "10px",
                  }}
                >
                  <FormLabel id="demo-controlled-radio-buttons-group">
                    {t("packages.form.unit")}
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={data.unit}
                    onChange={handleUnitChange}
                    sx={{ flexDirection: "row", alignItems: "center" }}
                  >
                    <FormControlLabel
                      value="Imperial"
                      control={<Radio />}
                      label={t("packages.form.imperial")}
                      sx={{ marginLeft: "20px" }}
                    />
                    <FormControlLabel
                      value="Metric"
                      control={<Radio />}
                      label={t("packages.form.metric")}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
            <div className="add__package_modalrow">
              <div className="add__package_modalinputwrap">
                <label className="add__package_profimagelbl">
                  <Upload /> {data.picture?.name ?? t("packages.form.uploadImage")}
                  <input
                    type="file"
                    size="60"
                    className="add__package_profimageinput"
                    onChange={handleFileChange}
                    accept=".jpg,.png"
                  />
                </label>
              </div>
            </div>
          </div>
          <div className="add__package_modalfooter">
            <div className="add__package_modalcncl" onClick={handleClose}>
              {t("common:actions.cancel")}
            </div>
            <div className="add__package_modalsave" onClick={handleSave}>
              {loading ? <Loader /> : t("common:actions.save")}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
